import wechat from '@/api/api-wechat';
import user from '@/api/api-user';
import tenant from '@/api/api-tenant';
import {
    localToken
} from "@/libs/func";

export default {
    state: {
        mobile: null,
        weixinuser: null
    },
    mutations: {
        setMobile(state, mobile) {
            state.mobile = mobile
        },
        setWeixinuser(state, weixinuser) {
            state.weixinuser = weixinuser
        }
    },
    actions: {
        // 登录
        handleLogin({
            dispatch,
            state,
            commit
        }, params) {
            return new Promise((resolve, reject) => {
                wechat.login(params).then(res => {
                    console.log(res, '登录 store');
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 测试登录
        handleLoginTest({
            state,
            commit
        }, params) {
            return new Promise((resolve, reject) => {
                wechat.loginTest(params).then(res => {
                    console.log(res, '登录 store');
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取用户相关信息
        getUserInfo({
            state,
            commit
        }) {
            return new Promise((resolve, reject) => {
                user.getBaseInfo().then(res => {
                    let data = res;
                    // let weixinuser = localToken.getWeiXin()
                    data['name'] = localToken.getWeiXinName()
                    data['img'] = localToken.getWeiXinImg()
                    localToken.setIsSetPwd(res.isSetPwd) // IsSetPwd false 未设置密码 true  已设置密码
                        // localToken.setWeiXin(weixinuser);
                        // commit('setMobile', data.mobile)
                        // commit('setWeixinuser', weixinuser)
                        // alert(JSON.stringify(weixinuser))
                    resolve(data)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 清除缓存
        clearLocal({
            state,
            commit
        }) {

            return new Promise((resolve, reject) => {
                let res = localToken.clearLocal()
                commit('setMobile', null)
                commit('setWeixinuser', null)
                resolve(true)
            })
        },
        // 获取是否设置密码字符
        getIsSetPwd({
            state,
            commit
        }) {

            return new Promise((resolve, reject) => {
                let isSetPwd = localToken.getIsSetPwd()
                resolve(isSetPwd)
            })
        },
        // 获取用户相关信息
        getTenantInfo({
            state,
            commit
        }) {
            return new Promise((resolve, reject) => {
                tenant.getTenantInfo().then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        checkDn({
            state,
            commit
        }, dn) {
            return new Promise((resolve, reject) => {
                localToken.setDn(dn);
                resolve(true)
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/module/user.js